import { render } from "./RcLabelsAndAnnotations.vue?vue&type=template&id=5ee8b349"
import script from "./RcLabelsAndAnnotations.vue?vue&type=script&lang=js"
export * from "./RcLabelsAndAnnotations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__